export default class PaymentsAbstractServices {
  static getMakeAPaymentMaximumAmount() {
    logger.error(`Payments:: getMakeAPaymentMaximumAmount() not implemented`);
  }

  static getMakeAPaymentReferenceData() {
    logger.error(`Payments:: getMakeAPaymentReferenceData() not implemented`);
  }

  static getCardDetail() {
    logger.error(`Payments:: getCardDetail() not implemented`);
  }

  static makePayment() {
    logger.error(`Payments:: makePayment() not implemented`);
  }

  static getReferenceData() {
    logger.error(`Payments:: getReferenceData() not implemented`);
  }

  static getPaymentSuccessReferenceData() {
    logger.error(`Payments:: getPaymentSuccessReferenceData() not implemented`);
  }

  static getPayments(memberNumber, personCode, years) {
    logger.error(`Payments:: getPayments(${memberNumber}, ${personCode}, ${years}) not implemented`);
  }

  static getPaymentsDocument(requestingPersonCode, accessingPersonCode, memberNumber, documentId) {
    logger.error(`Payments:: getPaymentsDocument(${requestingPersonCode}, ${accessingPersonCode}, ${memberNumber}, ${documentId}) not implemented`);
  }
}
